<template>
    <HeroSection :featureName="baseFeature.name" :icon="baseFeature.icon">
        <template #title>{{ baseFeature.description }}</template>
        <template #description>
            <div>Built right into the Event App, let your audience participate in your sessions.</div>
            <div class="mt-4">Present to big screens, integrate with attendee demographics to get rich data, and run it all easily from the facilitator panel.</div>

        </template>
        <template #content>
            <CmsAndApp :webImage="webImage" :appImage="appImage" />
        </template>
    </HeroSection>

    <Tips :title="baseFeature.name" :tips="tips" />
    <WorksWith :title="baseFeature.name" :integrations="integrations" />
    <Cta />
</template>

<script setup>
import Cta from '@/components/Blocks/Cta.vue';
import HeroSection from '@/components/HeroSection.vue';
import CmsAndApp from '@/components/Layouts/CmsAndApp.vue';
import Tips from '@/components/Blocks/Tips.vue';
import WorksWith from '@/components/Blocks/WorksWith.vue';
import { getFeaturesByIds } from '@/router/features';

import webImage from '@/images/screenshots/cms/profile-edit.png';
import appImage from '@/images/screenshots/app/theme-1/qanda.png';

const tips = [
    'Open Q&A early and let your speakers decide which questions to answer. Convert your questions into Live Polls for real-time engagement.',
    'Use the simplified "Speaker View" in front of your presenters to keep it nice and simple for new users.',
    'Add Points & Achievements to your Q&A sessions to drive engagement and keep your attendees interested.',
];

const baseFeature = getFeaturesByIds(['audienceparticipation'])[0];
const integrations = getFeaturesByIds(['eventapp', 'attendancetracking']);
</script>
